export default __webpack_public_path__ + "static/media/pagethree.43341720.txt";